import * as React from "react";
import { FormProvider } from "react-hook-form";

import arrow from "../../../../styles/svg/arrow.svg";
import Loader from "../../../../components/Loader";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import FormDialog from "../../../../components/Dialog/FormDialog";
import { RFHTextField, RHFSelect } from "../../../../components/RFH";
import { useMergeMilestoneState } from "./hooks/useMergeMilestoneState";

export default function MergeMilestonePopUp({
  open,
  close,
  unlockedMilestone,
  isSelectSourceMilestone,
  SelectedSourceMileStone,
}) {
  const {
    currentMilestone,
    epicDetail,
    handleClose,
    handleSubmit,
    isMobile,
    isPending,
    isSubmitDisabled,
    methods,
    selectedTargetMilestone,
    setCurrentMilestone,
    setSelectedTargetMilestone,
    sourceMilestoneOptions,
    targetMilestoneOptions,
  } = useMergeMilestoneState({
    close,
    unlockedMilestone,
    isSelectSourceMilestone,
    selectedSourceMilestone: SelectedSourceMileStone,
  });
  return (
    <>
      <FormProvider {...methods}>
        <FormDialog
          open={open}
          handleClose={handleClose}
          title={"Merge Milestone"}
          buttonTxt={"Merge"}
          handleSubmit={methods.handleSubmit(handleSubmit)}
          disabled={isSubmitDisabled}
          width={494}
          fullWidth={true}>
          <div className="move-ticket-form-dialogContent">
            <div
              className={
                isMobile
                  ? "mobile-ticket-reasign-step-container"
                  : "ticket-reasign-step-container"
              }>
              <div
                className={
                  isMobile
                    ? "mobile-current-target-board-name"
                    : "current-target-board-name"
                }>
                <p> Source Milestone </p>
                {isSelectSourceMilestone ? (
                  <div className="initial-step">
                    <RFHTextField
                      name=""
                      className="mui-status-field"
                      disabled
                      value={epicDetail?.epic_name}
                    />
                  </div>
                ) : (
                  <div className="initial-step">
                    <RHFSelect
                      name="currentMilestone"
                    sx={{
                      width: isMobile ? "100%" : "180px",
                    }}
                    className="mui-status-field"
                    required
                    >
                      {sourceMilestoneOptions.length > 0 ? (
                        sourceMilestoneOptions.map((option) => (
                          <CustomMenuItem
                            key={option.epic_id}
                            id={option.epic_id}
                            value={option.epic_id}
                            onClick={() => setCurrentMilestone(option.epic_id)}>
                            {option.epic_name}
                          </CustomMenuItem>
                        ))
                      ) : (
                        <CustomMenuItem>No Milestone</CustomMenuItem>
                      )}
                    </RHFSelect>
                  </div>
                )}
              </div>

              <img src={arrow} alt="" />
              <div
                className={
                  isMobile
                    ? "mobile-current-target-board-name"
                    : "current-target-board-name"
                }>
                <p>Target Milestone</p>
                <div className="initial-step">
                  <RHFSelect
                    name="targetMilestone"
                    sx={{
                      width: isMobile ? "100%" : "180px",
                    }}
                    className="mui-status-field"
                    required
                  >
                    {targetMilestoneOptions.length > 0 ? (
                      targetMilestoneOptions.map((option) => (
                        <CustomMenuItem
                          key={option.epic_id}
                          id={option.epic_id}
                          value={option.epic_id}
                          onClick={() =>
                            setSelectedTargetMilestone(option.epic_id)
                          }>
                          {option.epic_name}
                        </CustomMenuItem>
                      ))
                    ) : (
                      <CustomMenuItem>No Milestone</CustomMenuItem>
                    )}
                  </RHFSelect>
                </div>
              </div>
            </div>
          </div>
          {isPending && (
            <div className="popup-loader">
              <Loader color={"black"} />
            </div>
          )}
        </FormDialog>
      </FormProvider>
    </>
  );
}
